<sc-data-set-tile>
    <div class="tile">
        <sc-flex [centered]="true" fitHeight>
            {{profile.name}}
        </sc-flex>
    </div>
</sc-data-set-tile>
